import React from 'react';
import {
  Box,
  VStack,
  OptionTileField,
  DaysOfWeekField,
  SliderInputField,
  OptionGridField,
  OptionType,
  InputCardWrapper,
} from '@medely/ui-kit';
import { useWatch } from '@medely/ui-kit/react-hook-form';

type SchedulingPreferencesFormFieldsProps = {
  availableLabelOptions: OptionType[];
  positionOptions: OptionType[];
  showShiftPreferences: boolean;
  showDayPreferences: boolean;
  showFrequencyPreferences: boolean;
  showPositionPreferences: boolean;
};

export const SchedulingPreferencesFormFields = ({
  availableLabelOptions,
  positionOptions,
  showShiftPreferences,
  showDayPreferences,
  showFrequencyPreferences,
  showPositionPreferences,
}: SchedulingPreferencesFormFieldsProps) => {
  const preferredWeeklyTotalShiftsValue = useWatch({ name: 'preferred_weekly_total_shifts' });

  return (
    <VStack gap={2} py={2}>
      {showShiftPreferences && (
        <InputCardWrapper label="Preferred shifts" iconName="light-clock">
          <Box py={1}>
            <OptionTileField
              name="labels"
              multiple
              variant="text"
              options={availableLabelOptions}
            />
          </Box>
        </InputCardWrapper>
      )}
      {showDayPreferences && (
        <InputCardWrapper label="Preferred days" iconName="light-calendar-day">
          <Box py={1}>
            <DaysOfWeekField name="workdays" />
          </Box>
        </InputCardWrapper>
      )}
      {showFrequencyPreferences && (
        <InputCardWrapper
          label={`Preferred shifts per week: ${preferredWeeklyTotalShiftsValue ?? 1}`}
          iconName="light-stethoscope"
        >
          <Box py={1} px={1.5}>
            <SliderInputField name="preferred_weekly_total_shifts" min={1} max={7} />
          </Box>
        </InputCardWrapper>
      )}
      {showPositionPreferences && (
        <InputCardWrapper label="Preferred positions" iconName="light-hospital">
          <Box py={1}>
            <OptionGridField name="positions" options={positionOptions} />
          </Box>
        </InputCardWrapper>
      )}
    </VStack>
  );
};
